import React from 'react';
import { Grid, TextField } from '@mui/material';
import { FormikProps } from 'formik';
import { AddressDto } from '../../Models';
import { styled } from '@mui/material/styles';
import Provinces from '../../../../common/dropdowns/Provinces';

interface ResidentialFormProps {
  formik: FormikProps<AddressDto>;
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const ResidentialForm: React.FC<ResidentialFormProps> = ({ formik }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <StyledTextField
          fullWidth
          id="line1"
          name="line1"
          label="Address Line 1"
          value={formik.values.line1}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.line1 && Boolean(formik.errors.line1)}
          helperText={formik.touched.line1 && formik.errors.line1}
        />
      </Grid>
      
      <Grid item xs={12} md={6}>
        <StyledTextField
          fullWidth
          id="line2"
          name="line2"
          label="Address Line 2"
          value={formik.values.line2}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.line2 && Boolean(formik.errors.line2)}
          helperText={formik.touched.line2 && formik.errors.line2}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <StyledTextField
          fullWidth
          id="streetName"
          name="streetName"
          label="Street Name"
          value={formik.values.streetName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.streetName && Boolean(formik.errors.streetName)}
          helperText={formik.touched.streetName && formik.errors.streetName}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <StyledTextField
          fullWidth
          id="city"
          name="city"
          label="City"
          value={formik.values.city}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.city && Boolean(formik.errors.city)}
          helperText={formik.touched.city && formik.errors.city}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Provinces
          formik={formik}
          name="provinceId"
          value={formik.values.provinceId}
          error={Boolean(formik.touched.provinceId && formik.errors.provinceId)}
          touched={formik.touched.provinceId}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <StyledTextField
          fullWidth
          id="code"
          name="code"
          label="Postal Code"
          value={formik.values.code}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.code && Boolean(formik.errors.code)}
          helperText={formik.touched.code && formik.errors.code}
        />
      </Grid>
    </Grid>
  );
};

export default React.memo(ResidentialForm);